import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "components/ui/Select";
import type { MenuProvided } from "react-instantsearch-core";
import { connectMenu } from "react-instantsearch-dom";
import { FormattedMessage } from "react-intl";

const RealEstateFundOperatingSegmentMenu = connectMenu<MenuProvided>(({ items, refine, currentRefinement }) => {
  const selectValue = currentRefinement || "Todos";
  const selectedOption = selectValue === "Todos" ? null : items.find((item) => item.label === selectValue);

  return (
    <div className="space-y-4">
      <h3 className="font-aeonik text-base font-bold uppercase tracking-wide text-zinc-500">
        <FormattedMessage defaultMessage="Segmento" id="9WjEcd" />
      </h3>

      <Select
        value={selectValue}
        onValueChange={(value) => {
          refine(value === "Todos" ? "" : value);
        }}
      >
        <SelectTrigger>
          <SelectValue placeholder={<FormattedMessage defaultMessage="Todos" id="P8VfZA" />}>
            {selectedOption ? selectedOption.label : <FormattedMessage defaultMessage="Todos" id="P8VfZA" />}
          </SelectValue>
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="Todos">
            <FormattedMessage defaultMessage="Todos" id="P8VfZA" />
          </SelectItem>
          {items.map((item) => (
            <SelectItem key={item.label} value={item.label}>
              {item.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
});

export default function RealEstateFundOperatingSegment() {
  return <RealEstateFundOperatingSegmentMenu attribute="industrySegment" />;
}
